<template>
  <div v-if="activityList.length">
    <div class="title-wrap">
      <span class="title">近期活动</span>
      <!-- <span v-if="activityList.length" class="more" @click="gotoActivityList">查看更多</span> -->
    </div>
    <div class="home-cg">
      <div v-for="item in activityList" :key="item.id" class="cg-item" @click="gotoUrl(item)">
        <div class="cg-img">
          <el-image :src="require('@/assets/images/activity-icon.png')" />
        </div>
        <div class="cg-title">{{ item.activityName }}</div>
        <div class="cg-con">{{ item.organizer }}</div>
        <div class="cg-time">{{ item.activityTime }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activityList: [],
    }
  },
  mounted() {
    this.queryActivity()
  },
  methods: {
    queryActivity() {
      let qry = this.$query.new()
      this.$query.toR(qry, 'infoStatus', 1)
      this.$http({ method: 'get', url: '/zzmh/api/activity/page?query=' + this.$query.toEncode(qry) }).then((res) => {
        this.activityList = res.data.list.slice(0, 8)
      })
    },
    gotoActivityList() {
      this.$router.push({
        path: '/talent-activities',
      })
    },
    gotoUrl(item) {
      this.$router.push('/activity-detail/' + item.id)
    },
  },
}
</script>

<style lang="less" scoped>
@media screen {
  .no-msg {
    margin: 50px 0;
    text-align: center;
    color: #333;
  }
  .product-con {
    position: relative;
    display: flex;
    align-items: center;
  }
  .home-cg {
    margin-top: 30px;
    margin-bottom: 30px;
    display: grid;
    grid-template-columns: repeat(4, 272px);
    grid-template-rows: 190px;
    gap: 40px 37px;
    justify-content: center;
    align-items: center;
    .cg-item {
      background-image: url(../../../../assets/images/activity-bg.png);
      background-size: 100% 100%;
      box-shadow: 0px 4px 10px 0px rgba(27, 23, 117, 0.1);
      border-radius: 8px;
      padding: 24px 16px;
      height: 166px;
      cursor: pointer;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .cg-img {
        height: 60px;
        width: 60px;
      }
      .cg-con {
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #515151;
        letter-spacing: 0;
        text-align: center;
        font-weight: 400;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        margin-top: 4px;
        width: 100%;
      }
      .cg-title {
        margin-top: 4px;
        font-family: PingFangSC-Semibold;
        font-size: 20px;
        color: #515151;
        letter-spacing: 0;
        text-align: center;
        font-weight: 600;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        width: 100%;
      }
      .cg-time {
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #515151;
        letter-spacing: 0;
        text-align: center;
        margin-top: 4px;
        font-weight: 400;
      }
    }
  }
  @media (min-width: 769px) {
  }

  @media (max-width: 768px) {
  }
}
</style>
